import axios from 'axios';
import { envConfig } from '../config/env.config';
import { handleRequestError } from './authSession';

export const api = axios.create({
  baseURL: envConfig.apiUrl,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
});

export const analysisApi = axios.create({
  baseURL: envConfig.apiUrlAnalysis,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
});

const setupResponseInterceptor = (instance: any) => {
  instance.interceptors.response.use(
    (response: any) => {
      if (response.status < 200 || response.status >= 300) {
        throw new Error(`Error: ${response.status} - ${response.statusText}`);
      }
      return response;
    },
    (error: any) => {
      handleRequestError(error);
      return Promise.reject(error);
    },
  );
};

api.interceptors.request.use((request: any) => {
  const token = localStorage.getItem('token');
  if (token) {
    request.headers.Authorization = `Bearer ${token}`;
  }
  return request;
});

setupResponseInterceptor(api);
setupResponseInterceptor(analysisApi);
